<template>
  <div class="white-skin mdb-admin-sidenav">
    <mdb-side-nav
      logo="/img/logo.png"
      sideNavClass="sn-bg-4"
      mask="strong"
      right
      :OpenedFromOutside.sync="toggle"
    >
      <li>
        <!-- <form class="search-form" role="search"> -->
          <div class="mt-0 pt-1 nav-title" @click="wave">
            پنل پشتیبانی شرکت برنامه نویسان دانش برتر سهند
          </div>
        <!-- </form> -->
      </li>
      <li>
        <mdb-side-nav-nav>
          <mdb-side-nav-item
            
            @click.native="width < 1440 && toggleSideNav(false)"
            icon="tachometer-alt"
            to="/"
            >داشبرد</mdb-side-nav-item
          >
          <mdb-side-nav-cat name="تنظیمات کاربری" icon="user">
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              :to="'/profile/'+this.$store.state.user.UserId+'/edit'"
              >پروفایل</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              :to="'/account/'+this.$store.state.user.UserId+'/changePassword'"
              >تغییر رمز عبور</mdb-side-nav-item
            >
          </mdb-side-nav-cat>

          <mdb-side-nav-cat name="پشتیبانی" icon="support" >
            <mdb-side-nav-item
              to="/tickets"
              @click.native="width < 1440 && toggleSideNav(false)"
              >تیکت ها</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/tickets/new"
              @click.native="width < 1440 && toggleSideNav(false)"
              >تیکت جدید</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          
          <mdb-side-nav-cat name="امور مالی" icon="money" >
            <mdb-side-nav-item
              to="/invoices"
              @click.native="width < 1440 && toggleSideNav(false)"
              >فاکتورهای من</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/request/Invoice"
              @click.native="width < 1440 && toggleSideNav(false)"
              >تسویه فاکتور</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/wallet"
              @click.native="width < 1440 && toggleSideNav(false)"
              > کیف پول</mdb-side-nav-item
            >
            <mdb-side-nav-item
              to="/request/WalletCharge"
              @click.native="width < 1440 && toggleSideNav(false)"
              >شارژ کیف پول</mdb-side-nav-item
            >
          </mdb-side-nav-cat>
          <mdb-side-nav-cat name="سرویس ها" icon="th">
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/Request/Service"
              >ثبت سفارش جدید سرویس</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/Request/Course"
              >ثبت نام دوره آموزشی</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/Request/Package"
              >ثبت سفارش پکیچ</mdb-side-nav-item
            >
            <mdb-side-nav-item
              @click.native="width < 1440 && toggleSideNav(false)"
              to="/Request/Product">ثبت سفارش محصول آماده</mdb-side-nav-item>
            
          </mdb-side-nav-cat>

          <!-- <mdb-side-nav-cat name="ابزار ها" icon="wrench">
            <mdb-side-nav-item
                @click.native="width < 1440 && toggleSideNav(false)"
                to="/Statistician">
                آمارگیر سایت
            </mdb-side-nav-item>
          </mdb-side-nav-cat> -->

        </mdb-side-nav-nav>
      </li>
    </mdb-side-nav>
  </div>
</template>

<script>
import {
  mdbSideNav,
  mdbSideNavNav,
  mdbSideNavCat,
  mdbSideNavItem,
  waves
} from "mdbvue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SideNav",
  props: {
    waves: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean
    }
  },
  components: {
    mdbSideNav,
    mdbSideNavNav,
    mdbSideNavCat,
    mdbSideNavItem
  },
  data() {
    return {
      active: 0,
      elHeight: 0,
      windowHeight: 0,
      toggle: true,
      width: 0
    };
  },
  computed: mapGetters(["sidenav"]),
  methods: {
    ...mapActions(["toggleSideNav"]),
    afterEnter(el) {
      el.style.maxHeight = "1000px";
    },
    beforeLeave(el) {
      el.style.maxHeight = 0;
    },
    setWidth() {
      this.width = window.innerWidth;
    }
  },
  mounted() {
    this.setWidth();
    window.addEventListener("resize", this.setWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWidth);
  },
  watch: {
    toggle(value) {
      this.toggleSideNav(value);
    },
    sidenav(value) {
      this.toggle = value;
    },
    width(value) {
      if (value < 1440) {
        this.toggle = false;
      } else this.toggle = true;
    }
  },
  mixins: [waves]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.side-nav {
  opacity: 1 !important;
  transition: transform 0.3s linear !important;
}
</style>
